import { FilterType } from '@vk-hr-tek/core/filter';

export class StartDownloadXlsxDto {
  filters?: FilterType;
}
